export function createRetencion() {
  return {
    Clave: '',
    EmpresaId: 0,
    Nombre: '',
    ClaveErp: '',
    Porcentaje: null,
    EsActivo: true
  };
}
